const removeSessionAuthToken = () => {
    window.localStorage.removeItem('at');
};

export default removeSessionAuthToken;
